export const gradients = {
	scrims: {
		z0Top: `linear-gradient(
            to bottom,
            rgba(0, 0, 0, 0.5) 0%,
            rgba(0, 0, 0, 0.445219) 10.67%,
            rgba(0, 0, 0, 0.395894) 19.64%,
            rgba(0, 0, 0, 0.351473) 27.12%,
            rgba(0, 0, 0, 0.311403) 33.33%,
            rgba(0, 0, 0, 0.275132) 38.51%,
            rgba(0, 0, 0, 0.24211) 42.88%,
            rgba(0, 0, 0, 0.211783) 46.65%,
            rgba(0, 0, 0, 0.183601) 50.06%,
            rgba(0, 0, 0, 0.157011) 53.33%,
            rgba(0, 0, 0, 0.131461) 56.68%,
            rgba(0, 0, 0, 0.1064) 60.33%,
            rgba(0, 0, 0, 0.0812747) 64.52%,
            rgba(0, 0, 0, 0.0555344) 69.46%,
            rgba(0, 0, 0, 0.0286268) 75.38%,
            rgba(0, 0, 0, 0) 82.5%
        )`,
        z0Bottom: `linear-gradient(
            to top,
            hsla(0, 0%, 4%, 0.75) 0%,
            hsla(0, 0%, 4%, 0.74) 8.1%,
            hsla(0, 0%, 4%, 0.714) 15.5%,
            hsla(0, 0%, 4%, 0.672) 22.5%,
            hsla(0, 0%, 4%, 0.618) 29%,
            hsla(0, 0%, 4%, 0.556) 35.3%,
            hsla(0, 0%, 4%, 0.486) 41.2%,
            hsla(0, 0%, 4%, 0.412) 47.1%,
            hsla(0, 0%, 4%, 0.338) 52.9%,
            hsla(0, 0%, 4%, 0.264) 58.8%,
            hsla(0, 0%, 4%, 0.194) 64.7%,
            hsla(0, 0%, 4%, 0.132) 71%,
            hsla(0, 0%, 4%, 0.078) 77.5%,
            hsla(0, 0%, 4%, 0.036) 84.5%,
            hsla(0, 0%, 4%, 0.01) 91.9%,
            hsla(0, 0%, 4%, 0) 100%
        )`,
	},
};

